export default __webpack_public_path__ + "static/media/Open API Integration.c82a337c.md";